module.exports = __webpack_public_path__ + "media/packs/images/flags/SI-6a8751e26ef0b129ab0469d7c261c5d6.svg";